import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_ENDPOINTS } from "../../shared/constants/constants";
import { useCustomAxios } from "../../shared/lib/customAxios";

export const downloadInventoryBulkUploadTemplate = createAsyncThunk(
    "inventory/downloadBulkUploadTemplate",
    async () => {
      try {
        // console.log("excel download handler..");
        const s3Url = `https://prism-public-assets.s3.ap-south-1.amazonaws.com/Inventory_Bulk_Upload.xlsx`;
        
        // Create a temporary anchor element
        const anchor = document.createElement("a");
        anchor.href = s3Url;
        anchor.download = 'PRISM Inventory Template.xlsx'; // Set the desired file name
        anchor.click()
        return { status: "SUCCESS"};
      } catch (error: any) {
        return {
          error: error.response.data.message,
          status: error.response.status,
        };
      }
    }
  );

export const searchInventoryItems = createAsyncThunk(
    'inventory/searchItems',
    async (data: any) => {
        const { axiosPost } = useCustomAxios();
        const { queryParams, reqBody } = data;
        try {
            let url = API_ENDPOINTS.getInventoryItems;
            Object.entries(queryParams).forEach(
                ([key, value], index) =>
                    (url = url + `${index > 0 ? '&' : '?'}${key}=${encodeURIComponent(value as string ?? '')}`)
            );
            const response = await axiosPost(url, reqBody);

            return { data: response.data, status: response.status };
        } catch (error: any) {
            return {
                error: error.response.data.message,
                status: error.response.status,
            };
        }
    }
)

export const getInventoryItemById = createAsyncThunk(
    'inventory/getById',
    async (inventoryItemId: string) => {
        const { axiosGet } = useCustomAxios();
        try {
            let url = API_ENDPOINTS.getInventoryItemById;
            url = url.replace(":inventoryItemId", inventoryItemId);
            const response = await axiosGet(url);

            return { data: response.data, status: response.status };
        } catch (error: any) {
            return {
                error: error.response.data.message,
                status: error.response.status,
            };
        }
    }
)

export const updateInventoryItem = createAsyncThunk(
    'inventory/updateItem',
    async (reqBody: any) => {
        // console.log(reqBody)
        const { axiosPost } = useCustomAxios();
        try {
            const response = await axiosPost(API_ENDPOINTS.updateInventoryItem, reqBody
            );
            return { data: response.data, status: response.status };
        } catch (error: any) {
            return {
                error: error.response.data.message,
                status: error.response.status,
            };
        }
    }
);

export const bulkUploadInventoryItems = createAsyncThunk(
    'inventory/bulkUpload',
    async (reqBody: any) => {
        // console.log(reqBody)
        const { axiosPost } = useCustomAxios();
        try {
            const response = await axiosPost(API_ENDPOINTS.inventoryBulkUpload, reqBody);
            return { data: response.data, status: response.status };
        } catch (error: any) {
            return {
                error: error.response.data.message,
                status: error.response.status,
            };
        }
    }
);

export const createInventoryItemIssuance = createAsyncThunk(
    'inventory/createIssuance',
    async (reqBody: any) => {
        const { axiosPost } = useCustomAxios();
        try {
            let url = API_ENDPOINTS.inventoryCreateItemIssuance;
            const response = await axiosPost(url, reqBody);

            return { data: response.data, status: response.status };
        } catch (error: any) {
            return {
                error: error.response.data.message,
                status: error.response.status,
            };
        }
    }
)

export const updateInventoryItemIssuance = createAsyncThunk(
    'inventory/updateIssuance',
    async (reqBody: any) => {
        const { axiosPost } = useCustomAxios();
        try {
            let url = API_ENDPOINTS.inventoryUpdateItemIssuance;
            const response = await axiosPost(url, reqBody);

            return { data: response.data, status: response.status };
        } catch (error: any) {
            return {
                error: error.response.data.message,
                status: error.response.status,
            };
        }
    }
)

export const updateInventoryItemIssuanceStatus = createAsyncThunk(
    'inventory/updateIssuanceStatus',
    async (reqBody: any) => {
        const { axiosPost } = useCustomAxios();
        try {
            let url = API_ENDPOINTS.inventoryUpdateItemIssuanceStatus;
            const response = await axiosPost(url, reqBody);

            return { data: response.data, status: response.status };
        } catch (error: any) {
            return {
                error: error.response.data.message,
                status: error.response.status,
            };
        }
    }
)

export const getInventoryItemIssuanceById = createAsyncThunk(
    'inventory/getInventoryIssuanceById',
    async ({data}: any) => {
        const { axiosGet } = useCustomAxios();
        try {
            const {inventoryItemId, queryParams} = data;
            let url = API_ENDPOINTS.inventoryGetItemIssuanceById;
            url = url.replace(":inventoryItemId", inventoryItemId);
            Object.entries(queryParams).forEach(
                ([key, value], index) =>
                    (url = url + `${index > 0 ? '&' : '?'}${key}=${encodeURIComponent(value as string ?? '')}`)
            );
            const response = await axiosGet(url);

            return { data: response.data, status: response.status };
        } catch (error: any) {
            return {
                error: error.response.data.message,
                status: error.response.status,
            };
        }
    }
)
export const searchInventoryItemIssuance = createAsyncThunk(
    'inventory/searchItemIssuance',
    async (queryParams: any) => {
        const { axiosGet } = useCustomAxios();
        try {
            let url = API_ENDPOINTS.inventorySearchItemIssuance;
            Object.entries(queryParams).forEach(
                ([key, value], index) =>
                    (url = url + `${index > 0 ? '&' : '?'}${key}=${encodeURIComponent(value as string ?? '')}`)
            );
            const response = await axiosGet(url);

            return { data: response.data, status: response.status };
        } catch (error: any) {
            return {
                error: error.response.data.message,
                status: error.response.status,
            };
        }
    }
)

export const getInventoryItemActivityDetails = createAsyncThunk(
    'inventory/getItemActivityDetails',
    async (queryParams: any) => {
        const { axiosGet } = useCustomAxios();
        try {
            let url = API_ENDPOINTS.inventoryGetItemActivityDetails;
            Object.entries(queryParams).forEach(
                ([key, value], index) =>
                    (url = url + `${index > 0 ? '&' : '?'}${key}=${encodeURIComponent(value as string ?? '')}`)
            );
            const response = await axiosGet(url);

            return { data: response.data, status: response.status };
        } catch (error: any) {
            return {
                error: error.response.data.message,
                status: error.response.status,
            };
        }
    }
)

export const getItemIssuanceRequestById = createAsyncThunk(
    'inventory/getItemIssuanceRequestbyId',
    async (itemIssuanceRequestId: string) => {
        const { axiosGet } = useCustomAxios();
        try {
            let url = API_ENDPOINTS.inventoryGetItemIssuanceRequestById;
            url = url.replace(":itemIssuanceRequestId", itemIssuanceRequestId);
            const response = await axiosGet(url);

            return { data: response.data, status: response.status };
        } catch (error: any) {
            return {
                error: error.response.data.message,
                status: error.response.status,
            };
        }
    }
)

export const searchItemIssuanceRequest = createAsyncThunk(
    'inventory/searchItemIssuanceRequest',
    async (data: any) => {
        const { axiosPost } = useCustomAxios();
        const { queryParams, reqBody } = data;
        try {
            let url = API_ENDPOINTS.inventorySearchItemIssuanceRequest;
            Object.entries(queryParams).forEach(
                ([key, value], index) =>
                    (url = url + `${index > 0 ? '&' : '?'}${key}=${encodeURIComponent(value as string ?? '')}`)
            );

            const response = await axiosPost(url, reqBody);

            return { data: response.data, status: response.status };
        } catch (error: any) {
            return {
                error: error.response.data.message,
                status: error.response.status,
            };
        }
    }
)

export const updateItemIssuanceRequestApproval = createAsyncThunk(
    'inventory/updateItemIssuanceRequestApproval',
    async (reqBody: any) => {
        const { axiosPost } = useCustomAxios();
        try {
            let url = API_ENDPOINTS.inventoryUpdateItemIssuanceRequestApproval;
            const response = await axiosPost(url, reqBody);

            return { data: response.data, status: response.status };
        } catch (error: any) {
            return {
                error: error.response.data.message,
                status: error.response.status,
            };
        }
    }
)

export const updateItemIssuanceRequest = createAsyncThunk(
    'inventory/updateItemIssuanceRequest',
    async (reqBody: any) => {
        const { axiosPost } = useCustomAxios();
        try {
            let url = API_ENDPOINTS.inventoryUpdateItemIssuanceRequest;
            const response = await axiosPost(url, reqBody);

            return { data: response.data, status: response.status };
        } catch (error: any) {
            return {
                error: error.response.data.message,
                status: error.response.status,
            };
        }
    }
)

export const updateItemActivityDetails = createAsyncThunk(
    'inventory/activity/update',
    async (reqBody: any, {rejectWithValue}) => {
        const { axiosPost } = useCustomAxios();
        try {
            let url = API_ENDPOINTS.inventoryUpdateItemActivity;
            const response = await axiosPost(url, reqBody);

            return { data: response.data, status: response.status };
        }  catch (error: any) {
            return rejectWithValue(error.response.data.message);
        }
    }
)